module.exports = {
  site: 'HRMS-ESS_HRMS',
  sessionTimeout: 60,
  apiVersion: 'api',
  defaultBaseURL: 'http://192.168.99.100/',
  mocker: false,
  mockerLogin: false
}



// WEBPACK FOOTER //
// ./env.js